import axios from 'axios';
import building from '../store/modules/building';
import store from '@/store/store'

const baseURL = process.env.VUE_APP_APP_URL;

const instance = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// --- Flag กันการยิง Refresh Token ซ้ำซ้อน (Concurrency Issue) ---
// กรณีหน้าเว็บโหลดพร้อมกัน 5 API แล้ว Token หมดอายุ
// เราต้องการให้มัน Refresh แค่ครั้งเดียว ไม่ใช่ยิงไป 5 ครั้ง
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Request Interceptor: แนบ Token
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // ถ้า Error 401 และยังไม่ได้ Retry (และไม่ใช่ path /auth/google เพราะการ login ไม่ควรเรียก refresh token)
    if (error.response && error.response.status === 401 && !originalRequest._retry && !['/auth/google', '/auth/test-login'].includes(originalRequest.url)) {

      // ป้องกันการ Refresh ซ้อนกันถ้ามีหลาย Request เข้ามาพร้อมกัน
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers['Authorization'] = 'Bearer ' + token;
            return instance(originalRequest);
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");

        if (!refreshToken) {
          throw new Error("No refresh token available");
        }

        // ยิงไปขอ Token ใหม่
        const response = await instance.post("/auth/refresh-token", {
          refreshToken: refreshToken,
        });

        const { accessToken } = response.data;

        // 1. เก็บ Token ใหม่
        localStorage.setItem("accessToken", accessToken);

        // 2. อัปเดต defaults
        instance.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;

        // 3. Process คิวที่รออยู่ (สำหรับ Request อื่นๆ ที่เข้ามาพร้อมกัน)
        processQueue(null, accessToken);

        // 4. ทำ request เดิมซ้ำ
        originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;
        return instance(originalRequest);

      } catch (refreshError) {
        // กรณี Refresh ไม่ผ่าน
        processQueue(refreshError, null);
        store.dispatch("auth/logout");
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);


export default {


  auth(method, data, configs) {
    switch (method) {
      case 'google':
        return instance.post("/auth/google", data);
      case 'refresh-token':
        return instance.post("/auth/refresh-token", data);
      case 'test-login':
        return instance.post("/auth/test-login", data);
      default:
        throw new Error(`Auth method ${method} not supported`);
    }
  },

  building(method, data, configs) {
    switch (method) {
      case 'get':
        return instance.get("/building");
      case 'post':
        return instance.post("/building", data);
      case 'put':
        return instance.put("/building", data);
      case 'delete':
        return instance.delete("/building" + (configs?.urlAppend || ""));
      default:
        break;
    }
  },
}
